import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ApsServiceService } from 'src/app/aps-service.service';

@Component({
  selector: 'app-userdetails',
  templateUrl: './userdetails.component.html',
  styleUrls: ['./userdetails.component.css']
})
export class UserdetailsComponent implements OnInit {
  loaderdata:any=false
  getname:any=localStorage.getItem('FirstName') + " "+localStorage.getItem('LastName')
  userid:any = localStorage.getItem('userid');
  useremail:any=""
  directory:any;
  getdatasub:any;
  rate_other:any='00';
  rate_usa:any='00';
  rate_canada:any='00';
  userdata:any;
  currentfull:any;
  usernamecheck:any
  flag:any=localStorage.getItem("flag");
  addressdisplay:any

  // flag:any=0


  form = new FormGroup({
    username:new FormControl('',Validators.required),
    password:new FormControl(''),
    Firstname: new FormControl('',Validators.required),
    lastname: new FormControl('',Validators.required),
    phone: new FormControl('', Validators.required),
    email: new FormControl('',Validators.required),
    address1: new FormControl('', Validators.required),
    address2: new FormControl(''),
    zip: new FormControl('', Validators.required),
    city: new FormControl('',Validators.required),
    state: new FormControl('', Validators.required),
    country: new FormControl('',Validators.required),
    Access: new FormControl('true', Validators.required),
   
  });
  get username(): any { return this.form.get('username'); }
  get password(): any { return this.form.get('password'); }
  get Firstname(): any { return this.form.get('Firstname'); }
  get lastname(): any { return this.form.get('lastname'); }
  get address1(): any { return this.form.get('address1'); }
  get address2(): any { return this.form.get('address2'); }
  get zip(): any { return this.form.get('zip'); }
  get state(): any { return this.form.get('state'); }
  get city(): any { return this.form.get('city'); }
  get country(): any { return this.form.get('country'); }
  get phone(): any { return this.form.get('phone'); }
  get email(): any { return this.form.get('email'); }
  get Access(): any { return this.form.get('Access'); }


  clearInputMethod1() { this.username.reset(); 
    this.Firstname.reset();this.lastname.reset(); this.phone.reset();
    this.email.reset(); this.Access.reset(); 
    this.country.reset(); this.city.reset(); this.state.reset();
    this.zip.reset(); this.address2.reset(); this.address1.reset();
  }

  constructor(private toastr: ToastrService,private router: Router,private searchitem: ApsServiceService) { }

  ngOnInit(): void {
    this.loaderdata=true
    this.searchitem.getUserdata(this.userid).subscribe((responce) => {
      //console.log(responce)
       if(responce.status){
        //  this.Firstname=responce.data.FirstName
        //  this.lastname=responce.data.LastName
        //  this.email=responce.data.Email
        //  this.useremail=responce.data.Email
        //  this.phone=responce.data.Phone
        //  this.address1=responce.data.Address_1
        //  this.address2=responce.data.Address_2
        //  this.zip=responce.data.zip
        //  this.city=responce.data.city
        //  this.state=responce.data.State
        //  this.country=responce.data.Country
         if(responce.data.directory){
          this.directory="ture"
         }else{
          this.directory="false"
         }
         //console.log(this.directory)
        this.useremail=responce.data.Email
        this.addressdisplay=responce.data.Address_1 + " "+  responce.data.Address_2 + ", "+ responce.data.city + ", "+ responce.data.State + ", "+ responce.data.Country 
        this.usernamecheck=responce.data.username

        this.form.setValue({username:responce.data.username,password:null,Firstname: responce.data.FirstName,
          lastname:responce.data.LastName, address1:responce.data.Address_1,
          address2:responce.data.Address_2, zip:responce.data.zip,
          state:responce.data.State, city: responce.data.city,
          country:responce.data.Country, phone: responce.data.Phone, 
          email:responce.data.Email, Access:responce.data.directory.toString()}); 
          this.loaderdata=false
        }
        //(this.datas)
 
   })
  }

  logout() {
    localStorage.clear();
    window.location.reload();
  }
  
  onClickSubmit(data){
    if(this.form.valid){
      if(this.flag == 1){
        if(this.form.controls['password'].value != null){
          var userid = localStorage.getItem('userid');
    //console.log(this.form.value)
    this.loaderdata=true
    if(this.usernamecheck == this.form.controls['username'].value){
       this.searchitem.uploaduser(userid,this.form.value,this.flag).subscribe((responce) => {
     //console.log(responce)
      if(responce.status){
        this.toastr.success('Record has been successfully Updated')
        this.loaderdata=false
        this.logout() 
      

      }else{
        this.toastr.error('Please try again','Error')
        this.loaderdata=false
      }

      })
    }else{
    this.searchitem.Getusername(this.form.controls['username'].value).subscribe((responce) => {
//console.log(responce)
if(responce.status){


    this.searchitem.uploaduser(userid,this.form.value,this.flag).subscribe((responce) => {
     //console.log(responce)
      if(responce.status){
        this.toastr.success('Record has been successfully Updated')
        this.loaderdata=false
        this.logout() 

      }else{
        this.toastr.error('Please try again','Error')
        this.loaderdata=false
      }

      })
  }else{
    this.toastr.error("username already exist")
    this.loaderdata=false
  }  
  })
  }
      }else{
        this.toastr.warning('password null')
        this.loaderdata=false
      }
    }
    else{
      var userid = localStorage.getItem('userid');
    //console.log(this.form.value)
    this.loaderdata=true
    this.searchitem.uploaduser(userid,this.form.value,this.flag).subscribe((responce) => {
     //console.log(responce)
      if(responce.status){
        this.toastr.success('Record has been successfully Updated')
        localStorage.setItem("directory",this.form.controls['Access'].value)
        localStorage.setItem('LastName',this.form.controls['lastname'].value)
        localStorage.setItem('FirstName',this.form.controls['Firstname'].value)

        window.location.reload();
        this.loaderdata=false

      }else{
        this.toastr.error('Please try again','Error')
        this.loaderdata=false
      }

  })
    }
    
}else{
  this.toastr.warning('Please fill fields')
}
  }

}
